import { render, staticRenderFns } from "./PaymentChildItem.vue?vue&type=template&id=776a74f5"
import script from "./PaymentChildItem.vue?vue&type=script&lang=js"
export * from "./PaymentChildItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports